module.exports = __webpack_public_path__ + "img/42.f24d53de.gif";